<template>
  <div id="app">
    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col-md-12 mt-4 mb-4"
          v-if="
            !accountsRetrievelId ||
              (accountsRetrievelResult && accountsRetrievelResult.status !== 0)
          "
        >
          <h4>Autogiro via BankID</h4>
          <p class="tagline pt-3 pb-2">
            Din donation stödjer Islamakademins viktiga arbete i Sverige. Genom
            din donation blir du kostnadsfritt medlem i föreningen
            Islamakademin.
          </p>
          <div class="row no-gutters">
            <div class="col-6 clickable" style="padding-right:5px">
              <b-card
                @click="yearlyPayment = false"
                :bg-variant="yearlyPayment === false ? 'info' : 'light'"
                :text-variant="yearlyPayment === false ? 'white' : ''"
              >
                Månadsvis
              </b-card>
            </div>
            <div class="col-6 clickable" style="padding-left:5px">
              <b-card
                @click="yearlyPayment = true"
                :bg-variant="yearlyPayment ? 'info' : 'light'"
                :text-variant="yearlyPayment ? 'white' : ''"
              >
                Årsvis
              </b-card>
            </div>
          </div>
          <p></p>
          <template v-if="yearlyPayment !== null">
            <b-form-group>
              <b-form-input
                v-model="ssn"
                placeholder="Personnr. (ÅÅÅÅMMDDXXXX)"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                :state="isValidSsn"
                :disabled="
                  loadingAccounts ||
                    (accountsRetrievelResult &&
                      accountsRetrievelResult.status === 1)
                "
                class="mt-2 mb-2"
                size="lg"
              ></b-form-input>
              <b-form-invalid-feedback
                >Ange personnumret med 12 siffror utan
                bindestreck</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-input
              v-if="
                !(
                  accountsRetrievelResult &&
                  accountsRetrievelResult.status === 1
                )
              "
              v-model="tempEmail"
              placeholder="Ange E-post"
              type="email"
              :disabled="loadingAccounts || success"
              class="mt-2 mb-2"
              size="lg"
            ></b-form-input>
            <b-form-group>
              <b-form-input
                v-model="email"
                placeholder="Bekräfta E-post"
                type="email"
                :disabled="
                  loadingAccounts ||
                    (accountsRetrievelResult &&
                      accountsRetrievelResult.status === 1)
                "
                :state="isValidEmail"
                @paste.prevent="
                  '';


                "
                class="mt-2 mb-2"
                size="lg"
              ></b-form-input>
              <b-form-invalid-feedback
                >Kontrollera din inmatning</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-select
              v-model="bank"
              :options="options"
              :disabled="
                loadingAccounts ||
                  (accountsRetrievelResult &&
                    accountsRetrievelResult.status === 1)
              "
              class="mt-2 mb-2"
              size="lg"
            ></b-form-select>
            <b-form-checkbox
              v-if="
                !(
                  accountsRetrievelResult &&
                  accountsRetrievelResult.status === 1
                )
              "
              v-model="otherDevice"
              name="check-button"
              style="margin: 5px 0; text-align:left"
              switch
            >
              Legitimera med BankID via annan enhet
            </b-form-checkbox>
            <template
              v-if="
                accountsRetrievelResult && accountsRetrievelResult.status === 1
              "
            >
              <b-form-group
                v-if="!accountsRetrievelResult.accountNumbers[0].holderName"
              >
                <b-form-input
                  v-model="name"
                  :disabled="success"
                  placeholder="Ange för- och efternamn"
                  type="text"
                  :state="isValidName"
                  class="mt-2 mb-2"
                  size="lg"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Ange ditt fullständiga namn</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-select
                :disabled="success"
                v-model="bankAccount"
                :options="accounts"
                class="mt-2 mb-2"
                size="lg"
              ></b-form-select>
              <b-form-select
                v-model="amount"
                :disabled="success"
                :options="amounts"
                class="mt-2 mb-2"
                size="lg"
              ></b-form-select>
              <b-form-group>
                <b-form-input
                  v-if="!amount"
                  v-model="customAmount"
                  type="number"
                  placeholder="Belopp"
                  :disabled="success"
                  :state="isValidAmount"
                  class="mt-2 mb-2"
                  size="lg"
                ></b-form-input>
                <b-form-invalid-feedback
                  ><span v-if="yearlyPayment"
                    >För donation årsvis är minsta belopp 200 kr</span
                  ><span v-else
                    >För donation månadsvis är minsta belopp 25 kr</span
                  ></b-form-invalid-feedback
                >
              </b-form-group>
            </template>
            <b-alert
              variant="danger"
              class="mt-2 mb-2"
              show
              v-if="
                accountsRetrievelResult && accountsRetrievelResult.status !== 1
              "
            >
              Det gick tyvärr inte att hämta dina kontouppgifter. Försök igen.
            </b-alert>
            <b-alert variant="success" class="mt-2 mb-2" show v-if="success">
              Tack för att du donerar!
            </b-alert>
            <b-button
              v-if="
                !accountsRetrievelResult ||
                  (accountsRetrievelResult &&
                    accountsRetrievelResult.status !== 1)
              "
              @click="initiateAccountsRetrievel"
              :disabled="loadingAccounts || !isValidEmail || !isValidSsn"
              variant="info"
              size="md"
              class="mt-3"
              pill
              >Hämta konto med BankID</b-button
            >
          </template>
          <template
            v-if="
              accountsRetrievelResult &&
                accountsRetrievelResult.status === 1 &&
                !success
            "
          >
            <p class="terms pt-3">
              För autogiroprenumeranter ingår kostnadsfritt medlemskap i
              föreningen. Genom att slutföra samtycker jag till medlemskapet och
              att en kontoinformationstjänst tillhandahålls i enlighet med
              <a
                href="https://app.billecta.com/ht/accountinformationservices"
                target="_blank"
                >Billecta Payments användarvillkor</a
              >.
            </p>
            <b-button
              @click="finish"
              :disabled="loading || success || !isValidAmount || !isValidName"
              variant="success"
              size="md"
              class="mt-3"
              pill
              block
              >Slutför</b-button
            >
          </template>
          <div class="pt-4">
            <img
              class="logo"
              src="https://islamakademin.se/wp-content/uploads/2017/07/Untitled-9.png"
            />
          </div>
        </div>
        <div
          class="col-md-6 m-4 pending"
          v-else-if="
            accountsRetrievelId &&
              loadingAccounts &&
              accountsRetrievelResult &&
              !accountsRetrievelResult.qr &&
              accountsRetrievelResult.status === 0
          "
        >
          <img src="./assets/phone-bankid.png" class="m-4" />
          <h4>Väntar på BankID</h4>
          <p>
            Om inte BankID-appen öppnas automatiskt, öppna din app manuellt.
          </p>
          <p>
            Det kan ta upp till 45 sekunder att få återkoppling från din bank
            efter att du legitimerat dig.
          </p>
          <b-spinner label="Spinning"></b-spinner>
        </div>
        <div
          class="col-md-6 m-4 pending"
          v-else-if="
            accountsRetrievelId &&
              loadingAccounts &&
              accountsRetrievelResult &&
              accountsRetrievelResult.qr &&
              accountsRetrievelResult.status === 0
          "
        >
          <img src="./assets/phone-bankid.png" class="m-4" />
          <h4>Legitimera dig</h4>
          <p>
            Öppna Mobilt BankID på din mobil eller surfplatta och scanna
            QR-koden.
          </p>
          <img
            style="width:100%"
            @click="startBankID(accountsRetrievelResult.bankIdAutostartToken)"
            :src="accountsRetrievelResult.qr"
          />
          <p>
            Det kan ta upp till 45 sekunder att få återkoppling från din bank
            efter att du legitimerat dig.
          </p>
          <b-spinner label="Spinning"></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "App",
  components: {},
  data() {
    return {
      url: "https://islamakademin.azurewebsites.net", //"https://localhost:44379", //
      loading: false,
      name: "",
      otherDevice: false,
      loadingAccounts: false,
      ssn: null,
      tempEmail: null,
      email: null,
      bank: null,
      bankAccount: null,
      yearlyPayment: null,
      options: [
        { value: null, text: "Välj bank" },
        { value: "OEB", text: "Danske Bank" },
        { value: "SHB", text: "Handelsbanken" },
        { value: "ICA", text: "Ica" },
        { value: "LFB", text: "Länsförsäkringar" },
        { value: "NB", text: "Nordea" },
        { value: "SBAB", text: "SBAB" },
        { value: "SEB", text: "SEB" },
        { value: "SKB", text: "Skandia" },
        { value: "SYD", text: "Sparbanken Syd" },
        { value: "FSPASB", text: "Sparbankerna" },
        { value: "FSPA", text: "Swedbank" },
      ],
      amount: 200,
      customAmount: 200,
      accountsRetrievelId: null,
      accountsRetrievelResult: null,
      accountsRetrievelPoller: null,
      success: false,
    };
  },
  mounted() {
    this.accountsRetrievelPoller = setInterval(() => {
      if (this.loadingAccounts && this.accountsRetrievelId) {
        this.getAccounts();
      }
    }, 1000);
  },
  computed: {
    accounts() {
      if (this.accountsRetrievelResult) {
        return this.accountsRetrievelResult.accountNumbers.map((item) => {
          return {
            value: item.clearingNo + "-" + item.accountNo,
            text: item.name + " - " + item.number,
          };
        });
      }
      return [];
    },
    amounts() {
      const list = [
        { value: 100, text: "100 kr" },
        { value: 200, text: "200 kr" },
        { value: 300, text: "300 kr" },
        { value: 500, text: "500 kr" },
        { value: 750, text: "750 kr" },
        { value: 1000, text: "1000 kr" },
        { value: 0, text: "Eget belopp" },
      ];
      return this.yearlyPayment
        ? list.filter((item) => item.value !== 100)
        : list;
    },
    isValidAmount() {
      if (this.yearlyPayment && this.amount === 0 && this.customAmount < 200) {
        return false;
      }
      if (!this.yearlyPayment && this.amount === 0 && this.customAmount < 25) {
        return false;
      }
      return true;
    },
    isValidEmail() {
      if (!this.email) {
        return null;
      }
      if (this.email !== this.tempEmail) {
        return false;
      }
      const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if (!this.email.match(regex)) {
        return false;
      }
      return true;
    },
    isValidSsn() {
      if (!this.ssn) {
        return null;
      }
      const regex = /^\d+$/;
      if (!this.ssn.match(regex)) {
        return false;
      }
      if (this.ssn.length !== 12) {
        return false;
      }
      return true;
    },
    isValidName() {
      if (this.accountsRetrievelResult?.accountNumbers[0]?.holderName) {
        return true;
      }
      return this.name.trim().length > 4;
    },
  },
  watch: {
    accounts(val) {
      if (val.length > 0) {
        this.bankAccount = val[0].value;
      }
    },
    "accountsRetrievelResult.qr"(val) {
      if (val) {
        this.$nextTick(() => {
          this.startBankID(
            this.accountsRetrievelResult.bankIdAutostartToken ?? null
          );
        });
      }
    },
    yearlyPayment(val) {
      if (val) {
        this.amount = 200;
      }
    },
  },
  methods: {
    initiateAccountsRetrievel() {
      this.loadingAccounts = true;
      axios
        .post(this.url + "/billecta/accounts", {
          bank: this.bank,
          ssn: this.ssn,
          otherDevice: this.otherDevice,
        })
        .then((result) => {
          this.accountsRetrievelId = result.data;
        })
        .catch(() => {
          this.loadingAccounts = false;
        });
    },
    getAccounts() {
      axios
        .get(this.url + "/billecta/accounts?id=" + this.accountsRetrievelId)
        .then((result) => {
          if (
            (result.data.isBankIdAutostartTokenRequired && result.data.qr) ||
            !result.data.isBankIdAutostartTokenRequired
          ) {
            this.accountsRetrievelResult = result.data;
            if (this.accountsRetrievelResult.status !== 0) {
              this.loadingAccounts = false;
            }
          }
        });
    },
    finish() {
      this.loading = true;
      const account = this.bankAccount.split("-");
      const payload = {
        bank: this.bank,
        ssn: this.ssn,
        email: this.email,
        name: this.accountsRetrievelResult.accountNumbers[0].holderName,
        clearingNumber: account[0],
        accountNumber: account[1],
        amount: !this.amount ? this.customAmount : this.amount,
        yearlyPayment: this.yearlyPayment,
      };
      if (!payload.name) {
        payload.name = this.name;
      }
      axios
        .post(this.url + "/billecta/autogiro", payload)
        .then(() => {
          this.success = true;
        })
        .catch((error) => {
          alert(
            "Ett fel inträffade. Försök igen! Error: " + JSON.stringify(error)
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    startBankID(token) {
      let link = "";
      if (
        navigator.userAgent.indexOf("CriOS") != -1 ||
        navigator.userAgent.indexOf("Chrome") != -1
      ) {
        link = `bankid:///?autostarttoken=${token}&redirect=null`;
      } else {
        link = `bankid:///?autostarttoken=${token}&redirect=${document.location}#goback`;
      }
      document.location = link;
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 600px;
  margin: 0 auto;

  .pending {
    font-size: 14px;
  }

  .terms {
    font-size: 11px;
    padding: 5px;
    text-align: left;
  }

  .tagline {
    font-size: 14px;
    text-align: left;
  }

  .logo {
    width: 100px;
  }

  .clickable {
    cursor: pointer;
  }
}
</style>
